"use strict";

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderEditor = void 0;

var _style = _interopRequireDefault(require("styled-jsx/style"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectSpread"));

var React = _interopRequireWildcard(require("react"));

var _core = require("@blueprintjs/core");

var _styledBlueprintjsx = require("@nteract/styled-blueprintjsx"); // https://github.com/jupyter/nbformat/blob/master/nbformat/v4/nbformat.v4.schema.json#L67


var tagStyle = {
  marginRight: "5px",
  color: "#0366d6",
  background: "#f1f8ff"
};
var authorStyle = {
  marginRight: "5px",
  fontStyle: "italic",
  background: "#E5E5E5"
};
var authorStyleBlack = (0, _objectSpread2["default"])({}, authorStyle, {
  color: "black"
});
var addTagMessage = React.createElement("span", null, "Add a tag");
var addAuthorMessage = React.createElement("span", null, "Add an author");

var HeaderEditor = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(HeaderEditor, _React$Component);

  function HeaderEditor(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, HeaderEditor);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(HeaderEditor).call(this, props));
    _this.state = {
      editMode: "none"
    };
    return _this;
  }

  (0, _createClass2["default"])(HeaderEditor, [{
    key: "render",
    value: function render() {
      var _this2 = this; // Otherwise assume they have their own editor component


      var _this$props = this.props,
          editable = _this$props.editable,
          headerData = _this$props.headerData,
          _onChange = _this$props.onChange;
      return React.createElement("header", {
        className: "jsx-".concat(_styledBlueprintjsx.blueprintCSS.__hash)
      }, React.createElement("div", {
        style: {
          background: "#EEE",
          padding: "10px"
        },
        className: "jsx-".concat(_styledBlueprintjsx.blueprintCSS.__hash)
      }, React.createElement(_core.H1, null, React.createElement(_core.EditableText, {
        value: headerData.title,
        placeholder: "Edit title...",
        disabled: !editable,
        onChange: function onChange(newText) {
          _onChange((0, _objectSpread2["default"])({}, headerData, {
            title: newText
          }));
        }
      })), React.createElement("div", {
        className: "jsx-".concat(_styledBlueprintjsx.blueprintCSS.__hash)
      }, headerData.authors.length <= 0 ? null : "By ", headerData.authors.map(function (t) {
        return React.createElement(_core.Tag, {
          key: t.name,
          large: true,
          minimal: true,
          style: authorStyle,
          onRemove: editable ? function () {
            _onChange((0, _objectSpread2["default"])({}, headerData, {
              authors: headerData.authors.filter(function (p) {
                return p.name !== t.name;
              })
            }));
          } : null
        }, t.name);
      }), this.state.editMode === "author" && React.createElement(_core.Tag, {
        style: authorStyleBlack
      }, React.createElement(_core.EditableText, {
        maxLength: 40,
        className: "author-entry",
        placeholder: "Enter Author Name...",
        selectAllOnFocus: true,
        onConfirm: function onConfirm(e) {
          _onChange((0, _objectSpread2["default"])({}, headerData, {
            authors: (0, _toConsumableArray2["default"])(headerData.authors).concat([{
              name: e
            }])
          }));

          _this2.setState({
            editMode: "none"
          });
        },
        onCancel: function onCancel() {
          return _this2.setState({
            editMode: "none"
          });
        }
      })) || React.createElement(_core.Tooltip, {
        content: addAuthorMessage,
        position: _core.Position.RIGHT,
        usePortal: false,
        disabled: !editable
      }, React.createElement(_core.Button, {
        icon: "add",
        className: "author-button",
        onClick: function onClick() {
          return _this2.setState({
            editMode: "author"
          });
        },
        minimal: true,
        disabled: !editable
      }))), React.createElement("div", {
        className: "jsx-".concat(_styledBlueprintjsx.blueprintCSS.__hash)
      }, headerData.tags.map(function (t) {
        return React.createElement(_core.Tag, {
          key: t,
          style: tagStyle,
          onRemove: editable ? function () {
            _onChange((0, _objectSpread2["default"])({}, headerData, {
              tags: headerData.tags.filter(function (p) {
                return p !== t;
              })
            }));
          } : null
        }, t);
      }), this.state.editMode === "tag" && React.createElement(_core.Tag, {
        style: tagStyle
      }, React.createElement(_core.EditableText, {
        maxLength: 20,
        placeholder: "Enter Tag Name...",
        selectAllOnFocus: true,
        onConfirm: function onConfirm(e) {
          _onChange((0, _objectSpread2["default"])({}, headerData, {
            tags: (0, _toConsumableArray2["default"])(headerData.tags).concat([e])
          }));

          _this2.setState({
            editMode: "none"
          });
        },
        onCancel: function onCancel() {
          return _this2.setState({
            editMode: "none"
          });
        }
      })) || React.createElement(_core.Tooltip, {
        content: addTagMessage,
        position: _core.Position.RIGHT,
        usePortal: false,
        disabled: !editable
      }, React.createElement(_core.Button, {
        icon: "add",
        minimal: true,
        onClick: function onClick() {
          return _this2.setState({
            editMode: "tag"
          });
        },
        disabled: !editable
      }))), React.createElement("div", {
        style: {
          marginTop: "10px"
        },
        className: "jsx-".concat(_styledBlueprintjsx.blueprintCSS.__hash)
      }, React.createElement(_core.EditableText, {
        maxLength: 280,
        maxLines: 12,
        minLines: 3,
        multiline: true,
        placeholder: "Edit description...",
        selectAllOnFocus: false,
        value: headerData.description,
        disabled: !editable,
        onChange: function onChange(newText) {
          _onChange((0, _objectSpread2["default"])({}, headerData, {
            description: newText
          }));
        }
      }))), React.createElement(_style["default"], {
        styleId: _styledBlueprintjsx.blueprintCSS.__hash,
        css: _styledBlueprintjsx.blueprintCSS
      }));
    }
  }]);
  return HeaderEditor;
}(React.Component);

exports.HeaderEditor = HeaderEditor;
(0, _defineProperty2["default"])(HeaderEditor, "defaultProps", {
  editable: true,
  theme: "light",
  headerData: {
    authors: [],
    title: "",
    description: "",
    tags: []
  },
  onChange: function onChange() {}
});